const objContext = JSON.parse(sessionStorage.getItem("context"));
if(objContext == null || objContext.store_name == null)
    location.href='index.html';
document.querySelector('.sidebar-profile-img img').src = objContext.store_image
document.querySelector('.sidebar-profile-name-store').innerHTML = objContext.store_name.replace(/\\/, '')

document.querySelector('.sidebar-profile-user').innerText = localStorage.getItem('current_user') || '';

const sectionTab = document.querySelectorAll('.sidebar-menu-container-section-tab');
sectionTab[2].classList.add('sidebar-menu-container-section-tab--active');
const instructionTemplate = '<div class="profile-form-__SIDE__">'+
'<div class="form-group">'+
'  <label class="input-label">__NAME__</label>'+
'  <input class="form-input" type="text" placeholder="Ejemplo: Caja, Mesa, etc." value="__INSTRUCTIONS__" autocomplete="off" required="" delivery_id="__ID__">'+
'</div>'+
'</div>'

var storeData = null

UI.showLoader();

fetch(
    BASE_URLS.Dinny.api + `/stores/${localStorage.getItem("currentStore")}?req_id=${new Date().getTime()}`,
    {
      credentials: 'include'
    }
).then(function(response){
    if(response.ok){
        response.json().then(function(store){
            storeData = store
            fetch(
                BASE_URLS.Dinny.api + '/delivery_paymentes/deliveries/list?req_id=' + new Date().getTime(), {
                    credentials: 'include'
                }
            ).then(function(response) {
                if (response.ok) {
                    response.json().then(function(json) {
                        json.forEach(deliveryMethod => {
                            if (deliveryMethod.type == "address" && location.hostname.toLowerCase() == "cms.dinnyapp.com")
                                return;

                            document.getElementById('select-delivery-method').insertAdjacentHTML(
                                'beforeend',
                                `<option value='${deliveryMethod.method_id}'>${deliveryMethod.name}</option>`
                            )
                        });
                        fetch(
                            BASE_URLS.Dinny.api + `/delivery_paymentes/payments/get/${localStorage.getItem("currentStore")}?req_id=` + new Date().getTime(), {
                                credentials: 'include'
                            }
                        ).then(function(response) {
                            if (response.ok) {
                                response.json().then(function(json) {
                                    if(json.length == 0){
                                        return UI.message({
                                            title: 'Método de entrega',
                                            content: 'Primero debes configurar los métodos de pago.',
                                            accept: 'Aceptar'
                                        }, function(){
                                            UI.showLoader()
                                            window.location.href = `${window.location.origin}/payment.html#formPayment`
                                        })
                                    }
                                    json.forEach(paymentMethod => {
                                        document.getElementById('available-payments').insertAdjacentHTML(
                                            'beforeend',
                                            `<div class="form-group-check">
                                                <input class="form-input-check" type="checkbox" value="" id="p-method-${paymentMethod.id}" name="payment">
                                                <label class="input-label-check" for="p-method-${paymentMethod.id}">${paymentMethod.label}</label>
                                            </div>`
                                        )
                                    });
                                })
                                UI.hideLoader()
                            }else{
                                UI.hideLoader()
                                if(response.status == 403){
                                    window.location.href = "login.html"
                                }else{
                                    UI.message({
                                        title: 'Método de entrega',
                                        content: 'Ocurrió un error al cargar la información de entregas.',
                                        accept: 'Aceptar'
                                    })
                                }
                            }
                        }).catch(function(){
                            UI.message({
                                title: 'Método de entrega',
                                content: 'Ocurrió un error al cargar la información de pagos.',
                                accept: 'Aceptar'
                            })
                            UI.hideLoader()
                        })
                    })
                }else{
                    UI.hideLoader()
                    if(response.status == 403){
                        window.location.href = "login.html"
                    }else{
                        UI.message({
                            title: 'Método de entrega',
                            content: 'Ocurrió un error al cargar la información de entregas.',
                            accept: 'Aceptar'
                        })
                    }
                }
            }).catch(function(){
                UI.message({
                    title: 'Método de entrega',
                    content: 'Ocurrió un error al cargar la información de entregas.',
                    accept: 'Aceptar'
                })
                UI.hideLoader()
            })
        })
    }else{
        UI.hideLoader()
        if(response.status == 403){
            window.location.href = "login.html"
        }else{
            UI.message({
                title: 'Método de entrega',
                content: 'Ocurrió un error al cargar la información de entregas.',
                accept: 'Aceptar'
            })
        }
    }
}).catch(function(){
    UI.message({
        title: 'Método de entrega',
        content: 'Ocurrió un error al cargar la información de la tienda.',
        accept: 'Aceptar'
    })
    UI.hideLoader()
})

document.getElementById('select-delivery-method').addEventListener('change', function(){
    storeData.payment_methods.forEach(element => {
        if(document.getElementById(`p-method-${element.id}`))
            document.getElementById(`p-method-${element.id}`).checked = false
        document.getElementById('input-delivery-instructions').value = ''
    });
    document.getElementById('address-send').style.display = 'none';
    if(this.value != 0){
        if (this.value === '2'){
            document.getElementById('input-delivery-instructions').value = 'Código QR'
            document.getElementById('input-delivery-instructions').parentNode.style.display = 'none';
        }else{
            if(this.value === '3'){
                document.getElementById('input-delivery-instructions').parentNode.style.display = 'none';
                UI.showLoader();
                fetch(
                    BASE_URLS.Dinny.api + `/delivery_paymentes/deliveries/groups?store_id=${objContext.store_id}&req_id=${new Date().getTime()}`,
                    {
                        credentials: 'include'
                    }
                )
                .then(function(response){
                    if(response.ok){
                        document.getElementById('address-send').style.display = 'block';
                        response.json().then(json => {
                            if(json.length > 0){
                                document.getElementById('specifficGroup').removeAttribute('disabled')
                                // document.getElementById('freeShipping').removeAttribute('disabled')
                            }
                            if(document.getElementById('input-delivery-instructions').value != 'Domicilio'){
                                const checkData = JSON.parse(document.getElementById('input-delivery-instructions').value)
                                if(checkData.delivery == 'Reparto Dinny'){
                                    document.getElementById('IndependantGroup').checked = true
                                }else{
                                    document.getElementById('specifficGroup').checked = true
                                    document.getElementById('freeShipping').removeAttribute('disabled')
                                }
                                console.log('--->', checkData)
                                if(checkData.condition){
                                    console.log('if')
                                    document.getElementById('freeShipping').checked = true
                                }else{
                                    console.log('else')
                                }
                            }
                        })
                    }else{
                        document.getElementById('select-delivery-method').value = '0'
                        return UI.message({
                            title: 'Método de entrega',
                            content: 'Ocurrió un error al cargar las agrupaciones.',
                            accept: 'Aceptar'
                        })
                    }
                })
                .catch(function(error){
                    console.log('error', error)
                })
                .finally(() => {
                    UI.hideLoader()
                })
            }else{
                document.getElementById('input-delivery-instructions').parentNode.style.display = 'flex';
            }
        }
        if(storeData.delivery_methods){
            const methods = storeData.delivery_methods.find(d => d.id == this.value)
            if(methods){
                document.getElementById('input-delivery-instructions').value = typeof methods.instructions == 'string' ? methods.instructions : JSON.stringify(methods.instructions)
                methods.payment_methods.forEach(payment => {
                    if(document.getElementById(`p-method-${payment.id}`))
                        document.getElementById(`p-method-${payment.id}`).checked = true
                });
            }
        }
    }
})
document.getElementById('specifficGroup').addEventListener('change', function(){
    if(this.checked){
        UI.message({
            title: 'Método de entrega',
            content: 'Las órdenes para su establecimiento se harán por una agrupación específica del establecimiento.',
            accept: 'Aceptar'
        })
        document.getElementById('freeShipping').removeAttribute('disabled')
        document.getElementById('IndependantGroup').checked = false
    }else{
        document.getElementById('freeShipping').checked = false
        document.getElementById('freeShipping').setAttribute('disabled', '')
    }
})
document.getElementById('IndependantGroup').addEventListener('change', function(){
    if(this.checked){
        document.getElementById('freeShipping').setAttribute('disabled', '')
        document.getElementById('freeShipping').checked = false
        document.getElementById('specifficGroup').checked = false
    }
})
document.getElementById('btn-save-store-delivery').addEventListener('click', function(e){
    e.preventDefault()
    if(document.getElementById('select-delivery-method').value != 0){
        if(!/^[a-záéíóúÁÉÍÓÚÜü\d\-_\s]{2,50}$/i.test(document.getElementById('input-delivery-instructions').value) && document.getElementById('select-delivery-method').value == 1){
            return UI.message({
                title: 'Método de entrega',
                content: 'Las instrucciones de entrega no son válidas. Deben tener al menos dos caracteres.',
                accept: 'Aceptar'
            })
        }
        let payments = []
        for (let index = 0; index < document.querySelectorAll('.form-input-check').length; index++) {
            const checkBox = document.querySelectorAll('.form-input-check')[index];
            if(checkBox.checked){
                payments.push(checkBox.id.replace('p-method-', ''))
            }
        }
        // if(payments.length == 0){
        //     return UI.message({
        //         title: 'Método de entrega',
        //         content: 'Debes seleccionar por lo menos un método de pago.',
        //         accept: 'Aceptar'
        //     })
        // }
        let body = {
            store_id: localStorage.getItem("currentStore"),
            method_id: document.getElementById('select-delivery-method').value,
            instructions: document.getElementById('input-delivery-instructions').value,
            payments: payments
        }
        if(document.getElementById('select-delivery-method').value == 3){
            if(!document.getElementById('IndependantGroup').checked && !document.getElementById('specifficGroup').checked){
                return UI.message({
                    title: 'Método de entrega',
                    content: 'Debes seleccionar un método de reparto.',
                    accept: 'Aceptar'
                })
            }
            let delivery = null
            let condition = null
            if(document.getElementById('specifficGroup').checked){
                delivery = document.getElementById('specifficGroup').value
                if(document.getElementById('freeShipping').checked)
                    condition = document.getElementById('freeShipping').value
            }
            if(document.getElementById('IndependantGroup').checked){
                delivery = document.getElementById('IndependantGroup').value
            }
            body.instructions = {
                delivery: delivery,
                condition: condition
            }
        }
        // return console.log(body)
        UI.showLoader()
        fetch(
            BASE_URLS.Dinny.api + `/delivery_paymentes/deliveries/add/?req_id=${new Date().getTime()}`,
            {
                credentials: 'include',
                body: JSON.stringify(body),
                method: 'post'
            }
        ).then(function(response){
            if(response.ok){
                window.location.reload()
            }else{
                UI.message({
                    title: 'Método de entrega',
                    content: 'Ocurrió un error al guardar la información. Por favor, inténtalo nuevamente.',
                    accept: 'Aceptar'
                })
            }
        }).catch(function(){
            UI.hideLoader()
            UI.message({
                title: 'Método de entrega',
                content: 'Ocurrió un error al cargar la información de la tienda.',
                accept: 'Aceptar'
            })
        })
    }else{
        UI.message({
            title: 'Método de entrega',
            content: 'No has seleccionado un método de entrega.',
            accept: 'Aceptar'
        })
    }
})